var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.816 2v9.388L1.061 9.59 0 10.676l3.566 3.652 3.566-3.652-1.06-1.086-1.756 1.797V2h-1.5ZM10 5.698h10v-1.5H10v1.5ZM18 11.198h-8v-1.5h8v1.5ZM10 16.698h3v-1.5h-3v1.5Z",
    fill: "currentColor"
  })));
};
export default SvgSort;